import React from "react";
import { withRouter } from 'react-router-dom';
import * as core from 'cw-ui-core';
import css from './Menu.scss';
import cx from 'classnames';

const Menu = (props) => {
  const onNavigate = (item) => {
    props.history.push(item.path);
  };

  return (
    <div className={cx(props.className, css.wrap)}>
      {props.items.map((item) => {
        const isSelected = window.location.pathname.split('/')[1] === item.path.split('/')[1];
        
        if (item.showInMenu) {
          return (
            <div
              key={item.id}
              className={cx(css.item, { [css.selectedItem]: isSelected })}
              onClick={() => { onNavigate(item); }}>
              <core.Image
                className={item.name ? css.logo : css.logoNoName}
                isInlineSVG={item.isInlineSVG}
                src={item.logo} />
              {item.name ? <div className={css.name}>{item.name}</div> : null}
            </div>
          );
        }
        else {
          return null;
        }
      })}
    </div>
  );
};

export default withRouter(Menu);


// WEBPACK FOOTER //
// ./src/components/Menu/Menu.jsx